var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import styled, { keyframes, ThemeContext } from 'styled-components';
import Icon from '../Icon/Icon';
import { IconName, IconSize } from '../Icon/Icon.enum';
const pulseAnimation = keyframes `
    0% {
      background-position: 0 0;
    }
    100% {
       background-position: -135% 0;
    }
`;
const BaseSkeleton = styled.div `
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  height: ${({ height }) => (height ? `${height}px` : '100%')};
  background: ${({ theme, isImage }) => {
    if (isImage) {
        return `linear-gradient(-90deg,${theme.colors.ui02},${theme.colors.ui01} 50%,${theme.colors.ui02})`;
    }
    return `linear-gradient(
      -90deg,${theme.colors.disabled02},${theme.colors.disabled01} 50%,${theme.colors.disabled02}
    )`;
}};
  background-size: 400% 400%;
  animation: ${pulseAnimation} 1.2s linear infinite;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Skeleton = (_a) => {
    var { isImage, height, width } = _a, props = __rest(_a, ["isImage", "height", "width"]);
    const theme = useContext(ThemeContext);
    return (_jsx(BaseSkeleton, Object.assign({ height: height, isImage: isImage, width: width }, props, { children: isImage && (_jsx(Icon, { color: theme.colors.disabled02, name: IconName.PICTURE_SKELETON, size: IconSize.SIZE20 }, void 0)) }), void 0));
};
export default Skeleton;
//# sourceMappingURL=Skeleton.js.map